module.exports = __webpack_public_path__ + "img/33.01d32d87.jpg";